import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { LOGO_LARGE_BLACK } from '../../../utils';

const RegisterSuccess = () => {
  const history = useHistory();
  function handleClick() {
    history.push('/login');
  }
  return (
    <>
      <div className="reset-password-wrapper reset-success">
        <div className="form-container">
          <div className="forgot-password-logo">
            <img src={LOGO_LARGE_BLACK} alt="BYGmusic" />
          </div>
          <span className="icon icon-round-msg" />
          <h2 className="request-sent-head">Account request sent!</h2>
          <p>
            Thank you for checking out BYGmusic. We are excited to work with you! Check your email for confirmation.
          </p>
          <ButtonGroup className="justify-content-center p-0">
            <Button
              color="primary"
              size="lg"
              element="inlineBlock"
              type="submit"
              onClick={handleClick}
            >
              Back to sign in
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </>
  );
};

export default RegisterSuccess;
